const mixpanelEvents = {
  logOut: 'log out',
  viewDashboard: 'view dashboard',
  viewLocationReport: 'view location report',
  changedOrganizationCover: 'changed organization cover',
  deletedOrganizationCover: 'deleted organization cover',
  viewAdvertisingSpaces: 'view advertising spaces table',
  exportAdvertisingSpaces: 'export advertising spaces',
  exportAdvertisingPackages: 'export advertising packages',
  importAdvertisingSpaces: 'import advertising spaces',
  viewAdvertisingSpace: 'view advertising space',
  viewAdvertisingPackage: 'view advertising package',
  viewAdvertisingPackageBookings: 'view advertising package bookings',
  viewAdvertisingSpaceBookings: 'view advertising space bookings',
  viewAdvertisingSpaceLayoutSketches: 'view advertising space layout sketches',
  downloadAdvertisingSpaceSingleLayoutSketch: 'download advertising space single layout sketch',
  downloadAdvertisingSpaceLayoutSketches: 'download advertising space all layout sketches',
  deleteAdvertisingSpace: 'delete advertising space',
  deleteAdvertisingPackage: 'delete advertising package',
  addAdvertisingSpace: 'add advertising space',
  editAdvertisingSpace: 'edit advertising space',
  addAdvertisingPackage: 'add advertising package',
  editAdvertisingPackage: 'edit advertising package',
  viewOrders: 'view orders table',
  viewOrder: 'view order',
  orderApproved: 'order approved',
  orderRejected: 'order rejected',
  orderBookingApproved: 'order bookings approved',
  orderBookingRejected: 'order booking rejected',
  orderBookingDeleted: 'order booking deleted',
  orderBookingRequestApproval: 'order booking request approval',
  orderBookingConfirmed: 'order booking confirmed',
  orderBookingUpdated: 'order booking updated',
  orderBookingAdd: 'order booking add',
  orderCancel: 'cancel order',
  orderKeyVisualUpdate: 'order update key visuals',
  orderKeyVisualDelete: 'order delete key visual',
  viewMediaPlans: 'view media plans table',
  viewMediaPlan: 'view media plan',
  exportMediaPlans: 'export media plans',
  deleteMediaPlan: 'delete media plan',
  orderMediaPlan: 'order media plan',
  viewBrandDetails: 'view brand details',
  mediaPlanAddBookings: 'media plans add bookings',
  mediaPlanUpdateBookings: 'media plans update bookings',
  mediaPlanDeleteBookings: 'media plans delete bookings',
  mediaPlanBookingSellingPriceUpdated: 'media plan booking selling price updated',
  mediaPlanUpdateKeyVisuals: 'media plans update key visuals',
  mediaPlanDeleteKeyVisuals: 'media plans delete key visuals',
  addMediaPlan: 'add media plan',
  editMediaPlan: 'edit media plan',
  viewNotificationsPage: 'view notifications page',
  viewNotificationsDrawer: 'view notifications drawer',
  signupRequestApprove: 'signup request approve',
  exportCompanies: 'exports companies',
  viewCompanyInfo: 'view company info',
  addCompany: 'add company',
  editCompany: 'edit company',
  importCompanies: 'import companies',
  viewCompanyTermsAndConditions: 'view company terms and conditions',
  updateCompanyTermsAndConditions: 'update company terms and conditions',
  viewCompanyClients: 'view company clients',
  addCompanyClients: 'add company client',
  editCompanyClients: 'edit company client',
  deleteCompanyClient: 'delete company client',
  importCompanyClients: 'import company clients',
  viewCompanyTeamMembers: 'view company team members',
  addCompanyTeamMembers: 'add company team members',
  editCompanyTeamMembers: 'edit company team members',
  deleteCompanyTeamMembers: 'delete company team members',
  viewCompanyAccountSettings: 'view company account settings',
  editCompanyAccountSettings: 'edit company account settings',
  viewCompanyLocations: 'view company locations',
  addCompanyLocation: 'add company location',
  editCompanyLocation: 'edit company location',
  deleteCompanyLocation: 'delete company location',
  importCompanyLocations: 'import company locations',
  exportCompanyLocations: 'export company locations',
  uploadLocationFloorPlans: 'upload location floor plans',
  viewCompanyTenants: 'view tenants',
  uploadProofToTenant: 'upload proof to tenant',
  updateCompanyDiscounts: 'update company discounts',
  viewCompanyRebatePolicies: 'view company rebate policies',
  addCompanyRebatePolicy: 'add company rebate policy',
  editCompanyRebatePolicy: 'edit company rebate policy',
  deleteCompanyRebatePolicy: 'delete company rebate policy',
  viewCalendar: 'view calendar',
  viewUserProfile: 'view user profile',
  updateUserProfile: 'update user profile',
  updateUserPassword: 'update user password',
  updateUserEmail: 'update user email',
  updateUserAvatar: 'update user avatar',
  updateUserNotifications: 'update user notification preferences',
  updateUserRegionLanguage: 'update user region and language',
  addComment: 'add comment',
  editComment: 'edit comment',
  deleteComment: 'delete comment',
  addServiceTasksView: 'add service tasks view',
  addService: 'add service',
  editService: 'edit service',
  deleteService: 'delete service',
  exportServices: 'export services',
  exportOrder: 'export order',
  orderBookingPriceUpdated: 'order booking price updated',
  orderBookingSellingPriceUpdated: 'order booking selling price updated',
  viewOrderLayoutSketches: 'view order layout sketches',
  downloadOrderSingleLayoutSketch: 'download order single layout sketch',
  downloadOrderLayoutSketches: 'download order all layout sketches',
};

export default mixpanelEvents;
